module.exports = __webpack_public_path__ + "img/no-person-img.f5ef426.png";